import styled from 'styled-components'

const LightGradient = styled.div`
  background: ${props => props.theme.gradients.light};
`

const VividGradient = styled.div`
  background: ${props => props.theme.gradients.vivid};
`

export { LightGradient, VividGradient }
